import Vue from "vue";
import Axios from "axios";
import conf from "@/config";
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import router from "@/router";

let axios = Axios.create({
    baseURL: conf.api.BASE_URL
});

if(localStorage.lt) {
    axios.defaults.headers.common["Authorization"] = localStorage.lt;
}

const refreshAuthLogic = err => {
    if(err.response.status == 403) {
        router.push("/error/403");
        localStorage.removeItem("lt");
        location.reload();
        return Promise.reject(err);
    }else {
        return Promise.resolve(err);
    }
}

createAuthRefreshInterceptor(axios, refreshAuthLogic, {
    statusCodes: [401,403]

});

Object.defineProperty(Vue.prototype, '$axios', { value: axios });

export default axios;